<template>
    <div>
        <textualCriticism></textualCriticism>
    </div>
</template>

<script>
import textualCriticism from "page/xSchool/stuManager/textualCriticism.vue";
export default {
  data(){
      return {
          
      }
  },
  components:{
      textualCriticism
  }
}
</script>

<style>

</style>
